var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryForwardOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C17.2505 2 20.2832 3.30257 22.5003 5.52875L22.5 4L22.5067 3.88338C22.5645 3.38604 22.9872 3 23.5 3C24.0523 3 24.5 3.44772 24.5 4V8L24.4933 8.11662C24.4355 8.61396 24.0128 9 23.5 9H19.5L19.3834 8.99327C18.886 8.93551 18.5 8.51284 18.5 8C18.5 7.44772 18.9477 7 19.5 7L21.1427 7.00037C19.2897 5.10803 16.7386 4 14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24C16.6897 24 19.2082 22.9345 21.0722 21.0699C21.4627 20.6793 22.0959 20.6792 22.4864 21.0697C22.877 21.4601 22.8771 22.0933 22.4867 22.4839C20.2513 24.72 17.2257 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2ZM13.5 8C14.0523 8 14.5 8.44772 14.5 9V13.5858L17.2071 16.2929C17.5976 16.6834 17.5976 17.3166 17.2071 17.7071C16.8166 18.0976 16.1834 18.0976 15.7929 17.7071L12.7929 14.7071C12.6054 14.5196 12.5 14.2652 12.5 14V9C12.5 8.44772 12.9477 8 13.5 8Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryForwardOutline);
export default __webpack_public_path__ + "static/media/history_forward_outline.7348dfd40e1f6e428146b2f7157490bb.svg";
export { ForwardRef as ReactComponent };